
export const menuData = [
    {
        title: 'Dashboard',
        key: 'dashboard',
        icon: 'icmn icmn-stats-bars',
        url: 'dashboard'
    },
    {
        title: 'Dashboards',
        key: 'dashboards',
        icon: 'icmn icmn-stats-bars',
        url: '',
        children: [
            {
                title: 'By Publisher',
                key: 'dashboardByPublisher',
                url: 'dashboardByPublisher'
            },
            {
                title: 'By Dsp',
                key: 'dashboardByDsp',
                url: 'dashboardByDsp'
            }
        ]
    },
    {
        title: 'Exchange',
        key: 'exchange',
        icon: 'icmn icmn-spinner4',
        url: '',
        children: [
            {
                title: 'Publisher',
                key: 'publishers',
                url: 'publishers'
            },
            {
                title: 'DSP',
                key: 'dsp',
                url: 'dsp'
            },
            {
                title: 'Mini Exchange',
                key: 'mini-exchange',
                url: 'mini-exchange'
            },
            {
                title: 'House Creative',
                key: 'house-creative',
                url: 'house-creative'
            },
            {
                title: 'House Ad Size',
                key: 'house-ad-size',
                url: 'house-ad-size'
            },
            {
                title: 'SOV Template',
                key: 'sov-template',
                url: 'sov-template'
            }
        ]
    },
    {
        title: 'Admin',
        key: 'admin',
        icon: 'icmn icmn-lock',
        url: '',
        children: [
            {
                title: 'Account',
                key: 'account',
                url: 'account',
            },
            {
                title: 'Blockchain Node',
                key: 'node',
                url: 'node',
            },
            {
                title: 'Deal',
                key: 'deal',
                url: 'deal'
            },
            {
                title: 'Test Request',
                key: 'request',
                url: 'request'
            }
        ]
    },
    {
        title: 'Reports',
        key: 'report',
        icon: 'icmn icmn-file-text2',
        url: '',
        children: [
            {
                title: 'By Publisher',
                key: 'reportPublisher',
                url: 'reportPublisher',
            },
            {
                title: 'By Dsps',
                key: 'reportDsp',
                url: 'reportDsp',
            },
            {
                title: 'Request/Response Ids',
                key: 'requestResponseIds',
                url: 'requestResponseIds',
            },
            {
                title: 'Rejection Reason',
                key: 'rejectionReason',
                url: 'rejectionReason',
            },
            {
                title: 'Scheduled reports',
                key: 'scheduled-report',
                url: 'scheduled-report',
            }
        ]
    },
    // {
    //     title: 'Raw reports',
    //     key: 'raw-report',
    //     icon: 'icmn icmn-file-text2',
    //     url: 'raw-report'
    // },
    {
        title: 'Validation',
        key: 'validation',
        icon: 'icmn icmn-checkmark2',
        url: 'validation'
    }
]
